import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';

function Appcost(props) {
    return (
        <div className="p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                        <div className="example" data-text="Mobile Tools">
                            <h2>AR/VR Mobile Tools For Customer Engagement And Traction</h2>

                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                        <p>The idea of installing augmented and virtual reality solutions in your organizational
                            processes is helping your exercise better control over your business proceedings. The
                            solutions range from virtual conferencing rooms, interactive kiosks, and virtual fitting
                            slots for ecommerce companies to location-based AR gaming and industrial manufacturing. The
                            purpose is to work with a VR/AR development studio to create content and experiences
                            tailored to your customers’ needs and help you maximize user engagement and revenue
                            generation.</p>
                        <Link to="/contact"
                              className="border_btn" aria-label="TekRevol Contact">Let's Connect!</Link>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Appcost;
